export const TYPE_OPTS = ({ variant } = {}) => {
  const dispatchDefault = {
    default: {
      background: 'bg-dark',
      text: '',
    },
    outline: {
      background: 'bg-dark',
      text: '',
    },
    ghost: {
      background: 'bg-dark',
      text: '',
    },
  };
  const dispatchSecondary = {
    default: {
      background: 'bg-brand-secondary-base',
      text: 'text-primitive-white',
    },
    outline: {
      background: 'bg-brand-secondary-muted',
      text: 'text-brand-secondary-base',
    },
    ghost: {
      background: 'bg-brand-secondary-muted',
      text: 'text-brand-secondary-base',
    },
  };
  const dispatchDanger = {
    default: {
      background: 'bg-utility-danger-base',
      text: 'text-primitive-white',
    },
    outline: {
      background: 'bg-utility-danger-muted',
      text: 'text-utility-danger-base',
    },
    ghost: {
      background: 'bg-utility-danger-muted',
      text: 'text-utility-danger-base',
    },
  };
  const dispatchWarning = {
    default: {
      background: 'bg-utility-warning-base',
      text: 'text-primitive-white',
    },
    outline: {
      background: 'bg-utility-warning-muted',
      text: 'text-utility-warning-base',
    },
    ghost: {
      background: 'bg-utility-warning-muted',
      text: 'text-utility-warning-base',
    },
  };
  const dispatchSuccess = {
    default: {
      background: 'bg-utility-success-base',
      text: 'text-primitive-white',
    },
    outline: {
      background: 'bg-utility-success-muted',
      text: 'text-utility-success-base',
    },
    ghost: {
      background: 'bg-utility-success-muted',
      text: 'text-utility-success-base',
    },
  };
  const dispatchInfo = {
    default: {
      background: 'bg-utility-info-base',
      text: 'text-primitive-white',
    },
    outline: {
      background: 'bg-utility-info-muted',
      text: 'text-utility-info-base',
    },
    ghost: {
      background: 'bg-utility-info-muted',
      text: 'text-utility-info-base',
    },
  };
  const dispatchDisabled = {
    background: 'bg-disabled',
    text: 'text-disabled',
  };

  return {
    default: dispatchDefault?.[variant],
    secondary: dispatchSecondary?.[variant],
    danger: dispatchDanger?.[variant],
    warning: dispatchWarning?.[variant],
    success: dispatchSuccess?.[variant],
    info: dispatchInfo?.[variant],
    disabled: dispatchDisabled,
  };
};

export const VARIANT_OPTS = ({ type } = {}) => {
  const dispatchDefault = {
    default: 'border border-transparent',
    secondary: 'border border-transparent',
    success: 'border border-transparent',
    info: 'border border-transparent',
    warning: 'border border-transparent',
    danger: 'border border-transparent',
  };
  const dispatchOutline = {
    default: 'border border-default',
    secondary: 'border border-brand-secondary-base',
    success: 'border border-utility-success-base',
    info: 'border border-utility-info-base',
    warning: 'border border-utility-warning-base',
    danger: 'border border-utility-danger-base',
  };
  const dispatchGhost = {
    default: 'border border-transparent',
    secondary: 'border border-transparent',
    success: 'border border-transparent',
    info: 'border border-transparent',
    warning: 'border border-transparent',
    danger: 'border border-transparent',
  };

  return {
    default: {
      border: dispatchDefault?.[type],
    },
    outline: {
      border: dispatchOutline?.[type],
    },
    ghost: {
      border: dispatchGhost?.[type],
    },
  };
};

export const AVATAR_OPTS = ({ radius }) => ({
  radius: radius === 'default' ? 'xs' : 'rounded',
  style: radius === 'default' ? { marginLeft: -1 } : { marginLeft: -2.5 },
});

export const RADIUS_OPTS = {
  default: 'rounded px-ds-4',
  rounded: 'rounded-full px-ds-4',
};

export const LEADING_TYPE = ['avatar', 'indicator'];

export const INDICATOR_TYPE_OPTS = {
  default: 'bg-white border',
  success: 'bg-utility-success-base',
  info: 'bg-utility-info-base',
  danger: 'bg-utility-danger-base',
  warning: 'bg-utility-warning-base',
};
